<aside class="sidebar d-flex flex-column h-100" [class.sidebar--collapsed]="collapsed">

  <!-- Header -->
  <div class="sidebar__header d-flex flex-column flex-shrink-0">
    <div class="sidebar__brand d-flex align-items-center gap-3">
      <div class="sidebar__logo d-flex align-items-center justify-content-center flex-shrink-0">
        <i class="material-icons">build</i>
      </div>
      @if (!collapsed) {
        <span class="sidebar__brand-text fw-bold text-nowrap">MechanicApp</span>
      }
    </div>
  </div>

  <!-- Navigation -->
  <nav class="sidebar__nav flex-grow-1 overflow-auto">
    @for (menu of menuData; track $index) {
      <app-menu-item
        [menuItem]="menu"
        [collapsed]="collapsed">
      </app-menu-item>
    }
  </nav>

  <!-- Toggle -->
  <div class="sidebar__toggle-wrapper flex-shrink-0 d-flex">
    <button
      class="sidebar__toggle d-flex align-items-center justify-content-center rounded-circle border-0"
      (click)="toggleCollapsed()"
      [title]="collapsed ? 'Expandir menú' : 'Colapsar menú'">
      <i class="material-icons">
        {{ collapsed ? 'chevron_right' : 'chevron_left' }}
      </i>
    </button>
  </div>

  <!-- Footer -->
  <div class="sidebar__footer flex-shrink-0">
    @if (!collapsed) {
      <span class="sidebar__version">v1.0</span>
    }
  </div>

</aside>
